module.exports = __webpack_public_path__ + "static/media/invisible.6aaa5c90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/lib/statusEffects/invisible.svg
// module id = 144
// module chunks = 0